import type { SVGProps } from 'react'
const LineTextColor = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M8.485 13 7.24 16H5.615L11 3h2l5.395 13H16.77l-1.245-3zm3.518-8.489L9.105 11.5H14.9zM4 18h16v3H4z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineTextColor }
